"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimePicker = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _pickers = require("@material-ui/pickers");

var _moment = _interopRequireDefault(require("@date-io/moment"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["value", "onChange"];
(0, _loadStyles.default)(".fcl-time-picker .MuiInput-input{font-size:.875rem;font-weight:400;line-height:1rem;padding:.5rem .625rem;border:.0625rem solid transparent;border-radius:.625rem;color:var(--color-flomni-gray-90);height:auto}.fcl-time-picker .MuiInput-input:hover{border-color:var(--color-flomni-gray-40)}");

var TimePicker = function TimePicker(props) {
  var value = props.value,
      onChange = props.onChange,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _moment.default
  }, /*#__PURE__*/_react.default.createElement(_pickers.TimePicker, (0, _extends2.default)({
    autoOk: true,
    InputProps: {
      disableUnderline: true
    },
    ampm: false,
    value: value,
    onChange: onChange,
    classes: {
      root: 'fcl-time-picker'
    }
  }, rest)));
};

exports.TimePicker = TimePicker;
TimePicker.propTypes = {
  /* component logic props */
  value: _propTypes.object.isRequired,
  onChange: _propTypes.func.isRequired
};
TimePicker.defaultProps = {};